/**
 * currentSeasonId constants
 */
export const SET_CURRENT_SEASON_ID = 'SET_CURRENT_SEASON_ID';
